import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { HomecardLabel } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';
import '@spotahome/ui-library/lib/components/Tooltip/Tooltip.css';

import './HomeCardLabels.scss';

const LabelOptions = {
  checkedLabel: {
    name: 'checked',
    content: () => trans('homecard.label.checked'),
    className: 'label--checked',
    color: 'grey-dark',
    TooltipContent: 'homecard.label.tooltip-checked'
  },
  topLandordLabel: {
    name: 'topLandlord',
    content: () => trans('homecard.label.top_lister'),
    className: 'label label--super-lister',
    color: 'spotahomeTopLandlord',
    TooltipContent: 'homecard.label.tooltip-top_lister'
  }
};

const HomeCardLabels = ({ checked, isSuperlister }) => {
  const { checkedLabel, topLandordLabel } = LabelOptions;

  return (
    <Fragment>
      {checked && (
        <HomecardLabel
          renderContent={checkedLabel.content}
          className={checkedLabel.className}
        />
      )}
      {isSuperlister && (
        <HomecardLabel
          renderContent={topLandordLabel.content}
          className={topLandordLabel.className}
        />
      )}
    </Fragment>
  );
};

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired,
  isSuperlister: PropTypes.bool.isRequired
};

export const generateHomeCardLabels = ({ checked, isSuperlister }) => () => (
  <HomeCardLabels checked={checked} isSuperlister={isSuperlister} />
);

export default generateHomeCardLabels;
